
const useProgramProps = (program) => {

    const key = program?.id + (program?.level && program?.level != 0 ? ("-" + program?.level) : "");

    return {
        key
    }
}

export default useProgramProps;
